module.exports = __webpack_public_path__ + "static/ariel.f7b19f72.png";


//////////////////
// WEBPACK FOOTER
// ./public/static/ariel.png
// module id = 440
// module chunks = 168707334958949